import React from "react";

function Color_NCol() {
  return (
    <div>
      <h1>Color_NCol Component</h1>
      <p>This is the Color NCol tutorial page content.</p>
    </div>
  );
}

export default Color_NCol;
